import { dataCaretsOpposite } from 'dls-icons-data'
import { createIcon } from '../common'

const IconCaretsOpposite = /*#__PURE__*/createIcon(dataCaretsOpposite)
export default IconCaretsOpposite
